<!-- Page Wrapper -->
<div id="wrapper">
  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">
    <!-- Main Content -->
    <div id="content">


      <!-- Begin Page Content -->
      <div class="container-fluid">
        <!-- Content Row -->
        <div class="row">
          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <div class="row">
              <div class="col-md-9">
                <div class="card shadow py-1 mb-2">
                  <div class="card-body">
                    <p-select
                      [options]="periodos"
                      [(ngModel)]="selectedPeriodo"
                      optionLabel="nombre"
                      optionValue="id"
                      placeholder="Periodos"
                      class="w-100"
                      (ngModelChange)="onPeriodoChange()"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3 pl-0">
                <div class="card shadow py-1 mb-2">
                  <div class="card-body d-flex justify-content-center">
                    <button class="btn btn-light" (click)="downloadReporteOc()">
                      <i class="bi bi-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <app-card-value-pair
              title="Ordenes de Compra"
              icon="bi bi-currency-dollar"
              [value]="formattedMontoOCTotales"
              borderBottomColor="#cfcfcf"
              [detailValue]="formattedCantidadOCTotales"
              [isLoading]="isLoadingTotalesOC"
            ></app-card-value-pair>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <div class="card shadow py-1 mb-2">
              <div class="card-body">
                <p-select
                  [options]="centrosGestion"
                  [(ngModel)]="selectedCentroGestion"
                  optionLabel="nombre_orgc"
                  optionValue="id_orgc"
                  placeholder="Centros de Gestión"
                  class="w-100"
                  [showClear]="true"
                  (ngModelChange)="onCentroGestionChange()"
                  [style.color]="'blue'"
                />
              </div>
            </div>

            <app-card-circular-chart
              title="OC por Recibir"
              icon="bi bi-currency-dollar"
              [value]="formattedMontoOCTotalesRecibir"
              borderBottomColor="#cfcfcf"
              [chartValue]="porcentajeTotalesRecibir"
              chartProgressColor="#FF6B00"
              [isLoading]="isLoadingTotalesRecibir"
            ></app-card-circular-chart>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <div class="card shadow py-1 mb-2">
              <div class="card-body">
                <p-select
                  class="w-100"
                  [disabled]="true"
                />
              </div>
            </div>

            <app-card-circular-chart
              title="OC por Facturar"
              icon="bi bi-currency-dollar"
              [value]="formattedMontoOCTotalesRecibir"
              borderBottomColor="#cfcfcf"
              [chartValue]="porcentajeTotalesRecibir"
              chartProgressColor="#FF6B00"
              [isLoading]="isLoadingTotalesRecibir"
            ></app-card-circular-chart>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <div class="card shadow py-1 mb-2">
              <div class="card-body">
                <p-select
                  [options]="proveedores"
                  [(ngModel)]="selectedProveedor"
                  optionLabel="nombre_empresa"
                  optionValue="id_empresa"
                  placeholder="Proveedores"
                  class="w-100"
                  [showClear]="true"
                  (ngModelChange)="onProveedorChange()"
                />
              </div>
            </div>

            <app-card-circular-chart
              title=" Proveedores"
              icon="bi bi-hash"
              [value]="formattedCantidadProveedores"
              borderBottomColor="#cfcfcf"
              [chartValue]="porcentajeProveedores"
              chartProgressColor="#FF6B00"
              [isLoading]="isLoadingCantidadProveedores"
            ></app-card-circular-chart>
          </div>
        </div>

        <!-- Content Row -->

        <div class="row">
          <!-- Area Chart -->
          <div class="col-md-6">
            <app-card-barline-chart
              title="Monto Ordenes de Compras"
              [labels]="labelsEvolucionOC"
              lineChartTitle="OC"
              [lineChartData]="cantidadeOCEvolucionOC"
              lineChartBorderColor="#ea721d"
              barChart1Title="Por recibir"
              [barChart1Data]="montoOCEvolucionOC"
              barChart1BorderColor="white"
              barChart1BackgroundColor="#f18b38"
              barChart2Title="Cantidad OC"
              [barChart2Data]="montoPorRecibirEvolucionOC"
              barChart2BorderColor="white"
              barChart2BackgroundColor="#ea721d"
              [isLoading]="isLoadingEvolucionOC"
            ></app-card-barline-chart>
          </div>

          <!-- Pie Chart -->
          <div class="col-md-3">
            <app-card-doughnut-chart
              title="Detalle OC"
              [labels]="['cotización', 'convenio', 'directa']"
              [values]="dataTipoCompra"
              [colors]="['#ffbc6c', '#ea721d', '#f18b38']"
              [value1]="formattedCantidadTipoCompra"
              label1="Cantidad"
              [value2]="formattedMontoTipoCompra"
              [value3]="formattedMontoPromedioTipoCompra"
              label3="Monto promedio OC"
              [isLoading]="isLoadingTipoCompra"
            />
          </div>

          <!-- Pie Chart -->
          <div class="col-md-3">
            <div class="card shadow mb-4 bloque-7">
              <!-- Card Header - Dropdown -->
              <div
                class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
              >
                <h6 class="m-0 font-weight-bold text-secondary">
                  Concentración de Proveedores
                </h6>
                <div class="dropdown no-arrow">
                  <a
                    class="dropdown-toggle"
                    href="#"
                    role="button"
                    id="dropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                  </a>
                  <div
                    class="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                    aria-labelledby="dropdownMenuLink"
                  >
                    <div class="dropdown-header">Dropdown Header:</div>
                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#">Something else here</a>
                  </div>
                </div>
              </div>
              <!-- Card Body -->

              <app-card-ranking
                [rankings]="rankingProveedores"
                title="Concentración de Proveedores"
                icon="bi-people-fill"
                [value]="formattedCantidadProveedores"
                [colors]="colors"
                [isLoading]="isLoadingRankingProveedores"
              />
            </div>
          </div>
        </div>

        <!-- Content Row -->
        <div class="row">
          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <app-card-bar-chart
              title="Centros de Gestión"
              icon="bi bi-cart"
              [value]="formattedCentrosGestionCentroOC"
              detailTitle="Compradores"
              [detailValue]="formattedUsuarioCentroOC"
              detailColor="#FF6B00"
              detailBackgroundColor="#FFF3EB"
              borderBottomColor="#cfcfcf"
              [chartLabels]="labelsEvolucionOC"
              [chartData]="usuariosCentroOCMonthly"
              chartBorderColor="rgba(255, 170, 108, 1)"
              chartBackgroundColor="rgba(255, 170, 108, 0.4)"
              [isLoading]="isLoadingCentroOC"
            ></app-card-bar-chart>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <app-card-bar-chart
              title="OC con Convenio"
              icon="bi bi-currency-dollar"
              [value]="formattedMontoOCConvenio"
              detailTitle="Cantidad"
              [detailValue]="formattedCantidadOCConvenio"
              detailColor="#FF6B00"
              detailBackgroundColor="#FFF3EB"
              borderBottomColor="#cfcfcf"
              [chartLabels]="labelsOCConvenioMonthly"
              [chartData]="cantidadOCConvenioMonthly"
              chartBorderColor="rgba(255, 170, 108, 1)"
              chartBackgroundColor="rgba(255, 170, 108, 0.4)"
              [isLoading]="isLoadingOCConvenio"
            ></app-card-bar-chart>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <app-card-bar-chart
              title="OC < MM$ 1"
              icon="bi bi-people-fill"
              [value]="formattedMontoOCMenorQue"
              detailTitle="Cantidad"
              [detailValue]="formattedCantidadOCMenorQue"
              detailColor="#FF6B00"
              detailBackgroundColor="#FFF3EB"
              borderBottomColor="#cfcfcf"
              [chartLabels]="labelsOCMenorQueMonthly"
              [chartData]="cantidadOCMenorQueMonthly"
              chartBorderColor="rgba(255, 170, 108, 1)"
              chartBackgroundColor="rgba(255, 170, 108, 0.4)"
              [isLoading]="isLoadingOCMenorQue"
            ></app-card-bar-chart>
          </div>

          <!-- Earnings (Monthly) Card Example -->
          <div class="col-xl-3 col-md-6 mb-4">
            <app-card-bar-chart
              title="OC > MM$ 50"
              icon="bi bi-chat"
              [value]="formattedMontoOCMayorQue"
              detailTitle="Cantidad"
              [detailValue]="formattedCantidadOCMayorQue"
              detailColor="#FF6B00"
              detailBackgroundColor="#FFF3EB"
              borderBottomColor="#cfcfcf"
              [chartLabels]="labelsOCMayorQueMonthly"
              [chartData]="cantidadOCMayorQueMonthly"
              chartBorderColor="rgba(255, 170, 108, 1)"
              chartBackgroundColor="rgba(255, 170, 108, 0.4)"
              [isLoading]="isLoadingOCMayorQue"
            ></app-card-bar-chart>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <footer class="sticky-footer bg-white">
      <div class="container my-auto">
        <div class="copyright text-center my-auto">
          <span>iConstruye 2024</span>
        </div>
      </div>
    </footer>
    <!-- End of Footer -->
  </div>
  <!-- End of Content Wrapper -->
</div>
<!-- End of Page Wrapper -->
